import { render, staticRenderFns } from "./moveDialog.vue?vue&type=template&id=aa320558&scoped=true"
import script from "./moveDialog.vue?vue&type=script&lang=js"
export * from "./moveDialog.vue?vue&type=script&lang=js"
import style0 from "./moveDialog.vue?vue&type=style&index=0&id=aa320558&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa320558",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa320558')) {
      api.createRecord('aa320558', component.options)
    } else {
      api.reload('aa320558', component.options)
    }
    module.hot.accept("./moveDialog.vue?vue&type=template&id=aa320558&scoped=true", function () {
      api.rerender('aa320558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/memorandum/components/moveDialog.vue"
export default component.exports